// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SampleReportRouteImport } from './routes/sample-report'
import { Route as SampleDealRouteImport } from './routes/sample-deal'
import { Route as SampleDashboardRouteImport } from './routes/sample-dashboard'
import { Route as SampleContactRouteImport } from './routes/sample-contact'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AgentdartRouteImport } from './routes/agentdart'
import { Route as AffiliateTermsRouteImport } from './routes/affiliate-terms'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ListsIndexRouteImport } from './routes/lists.index'
import { Route as HelpIndexRouteImport } from './routes/help.index'
import { Route as VerifyEmailTokenRouteImport } from './routes/verify-email_.$token'
import { Route as PartnersApplyRouteImport } from './routes/partners_.apply'
import { Route as ListsSlugRouteImport } from './routes/lists.$slug'
import { Route as HelpEmailConnectionsRouteImport } from './routes/help.email-connections'
import { Route as HelpSlugRouteImport } from './routes/help.$slug'
import { Route as ConnectClaudeRouteImport } from './routes/connect_.claude'
import { Route as ConnectChatgptRouteImport } from './routes/connect_.chatgpt'
import { Route as ConnectCapabilitiesRouteImport } from './routes/connect_.capabilities'
import { Route as ClaimTokenRouteImport } from './routes/claim.$token'
import { Route as AuthedTeamRouteImport } from './routes/_authed/team'
import { Route as AuthedSupportRouteImport } from './routes/_authed/support'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedBuyCreditsRouteImport } from './routes/_authed/buy-credits'
import { Route as AuthedAppRouteImport } from './routes/_authed/app'
import { Route as AuthedAgentRouteImport } from './routes/_authed/agent'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as IntegrationsOutlookCallbackRouteImport } from './routes/integrations.outlook.callback'
import { Route as IntegrationsGmailCallbackRouteImport } from './routes/integrations.gmail.callback'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthedSupportTicketIdRouteImport } from './routes/_authed/support_.$ticketId'
import { Route as AuthedPartnersResourcesRouteImport } from './routes/_authed/partners.resources'
import { Route as AuthedPartnersDashboardRouteImport } from './routes/_authed/partners.dashboard'
import { Route as AuthedDealsDealIdRouteImport } from './routes/_authed/deals.$dealId'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin.index'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin.users'
import { Route as AuthedAdminSuppressionRouteImport } from './routes/_authed/admin.suppression'
import { Route as AuthedAdminSupportRouteImport } from './routes/_authed/admin.support'
import { Route as AuthedAdminReferralsRouteImport } from './routes/_authed/admin.referrals'
import { Route as AuthedAdminPartnersRouteImport } from './routes/_authed/admin.partners'
import { Route as AuthedAdminLedgerRouteImport } from './routes/_authed/admin.ledger'
import { Route as AuthedAdminLeadsRouteImport } from './routes/_authed/admin.leads'
import { Route as AuthedAdminHarnessRouteImport } from './routes/_authed/admin.harness'
import { Route as AuthedAdminFailuresRouteImport } from './routes/_authed/admin.failures'
import { Route as AuthedAdminEmailsRouteImport } from './routes/_authed/admin.emails'
import { Route as AuthedAdminDirectoryContactsRouteImport } from './routes/_authed/admin.directory-contacts'
import { Route as AuthedAdminDashboardRouteImport } from './routes/_authed/admin.dashboard'
import { Route as AuthedAdminCreditsRouteImport } from './routes/_authed/admin.credits'
import { Route as AuthedDealsDealIdReportsRouteImport } from './routes/_authed/deals.$dealId_.reports'
import { Route as AuthedDealsDealIdRefineRouteImport } from './routes/_authed/deals.$dealId_.refine'
import { Route as AuthedDealsDealIdPlanRouteImport } from './routes/_authed/deals.$dealId_.plan'
import { Route as AuthedDealsDealIdDeckStudioRouteImport } from './routes/_authed/deals.$dealId_.deck-studio'
import { Route as AuthedDealsDealIdContactsRouteImport } from './routes/_authed/deals.$dealId_.contacts'
import { Route as AuthedDealsDealIdCapabilitiesRouteImport } from './routes/_authed/deals.$dealId_.capabilities'
import { Route as AuthedDealsDealIdAgentdartRouteImport } from './routes/_authed/deals.$dealId_.agentdart'
import { Route as AuthedAdminUsersUserIdRouteImport } from './routes/_authed/admin.users_.$userId'
import { Route as AuthedAdminSupportTicketIdRouteImport } from './routes/_authed/admin.support_.$ticketId'
import { Route as AuthedDealsDealIdTermSheetReportIdRouteImport } from './routes/_authed/deals.$dealId_.term-sheet.$reportId'
import { Route as AuthedDealsDealIdRaiseStrategyReportIdRouteImport } from './routes/_authed/deals.$dealId_.raise-strategy.$reportId'
import { Route as AuthedDealsDealIdModelReviewReportIdRouteImport } from './routes/_authed/deals.$dealId_.model-review.$reportId'
import { Route as AuthedDealsDealIdMarketCompsReportIdRouteImport } from './routes/_authed/deals.$dealId_.market-comps.$reportId'
import { Route as AuthedDealsDealIdInvestorsContactIdRouteImport } from './routes/_authed/deals.$dealId_.investors.$contactId'
import { Route as AuthedDealsDealIdDealUpdateReportIdRouteImport } from './routes/_authed/deals.$dealId_.deal-update.$reportId'
import { Route as AuthedAdminUsersUserIdDealsDealIdRouteImport } from './routes/_authed/admin.users_.$userId_.deals.$dealId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SampleReportRoute = SampleReportRouteImport.update({
            id: '/sample-report',path: '/sample-report',getParentRoute: () => rootRouteImport
          })
const SampleDealRoute = SampleDealRouteImport.update({
            id: '/sample-deal',path: '/sample-deal',getParentRoute: () => rootRouteImport
          })
const SampleDashboardRoute = SampleDashboardRouteImport.update({
            id: '/sample-dashboard',path: '/sample-dashboard',getParentRoute: () => rootRouteImport
          })
const SampleContactRoute = SampleContactRouteImport.update({
            id: '/sample-contact',path: '/sample-contact',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConnectRoute = ConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AgentdartRoute = AgentdartRouteImport.update({
            id: '/agentdart',path: '/agentdart',getParentRoute: () => rootRouteImport
          })
const AffiliateTermsRoute = AffiliateTermsRouteImport.update({
            id: '/affiliate-terms',path: '/affiliate-terms',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ListsIndexRoute = ListsIndexRouteImport.update({
            id: '/lists/',path: '/lists/',getParentRoute: () => rootRouteImport
          })
const HelpIndexRoute = HelpIndexRouteImport.update({
            id: '/help/',path: '/help/',getParentRoute: () => rootRouteImport
          })
const VerifyEmailTokenRoute = VerifyEmailTokenRouteImport.update({
            id: '/verify-email_/$token',path: '/verify-email/$token',getParentRoute: () => rootRouteImport
          })
const PartnersApplyRoute = PartnersApplyRouteImport.update({
            id: '/partners_/apply',path: '/partners/apply',getParentRoute: () => rootRouteImport
          })
const ListsSlugRoute = ListsSlugRouteImport.update({
            id: '/lists/$slug',path: '/lists/$slug',getParentRoute: () => rootRouteImport
          })
const HelpEmailConnectionsRoute = HelpEmailConnectionsRouteImport.update({
            id: '/help/email-connections',path: '/help/email-connections',getParentRoute: () => rootRouteImport
          })
const HelpSlugRoute = HelpSlugRouteImport.update({
            id: '/help/$slug',path: '/help/$slug',getParentRoute: () => rootRouteImport
          })
const ConnectClaudeRoute = ConnectClaudeRouteImport.update({
            id: '/connect_/claude',path: '/connect/claude',getParentRoute: () => rootRouteImport
          })
const ConnectChatgptRoute = ConnectChatgptRouteImport.update({
            id: '/connect_/chatgpt',path: '/connect/chatgpt',getParentRoute: () => rootRouteImport
          })
const ConnectCapabilitiesRoute = ConnectCapabilitiesRouteImport.update({
            id: '/connect_/capabilities',path: '/connect/capabilities',getParentRoute: () => rootRouteImport
          })
const ClaimTokenRoute = ClaimTokenRouteImport.update({
            id: '/claim/$token',path: '/claim/$token',getParentRoute: () => rootRouteImport
          })
const AuthedTeamRoute = AuthedTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthedRoute
          })
const AuthedSupportRoute = AuthedSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthedRoute
          })
const AuthedProfileRoute = AuthedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthedRoute
          })
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthedRoute
          })
const AuthedBuyCreditsRoute = AuthedBuyCreditsRouteImport.update({
            id: '/buy-credits',path: '/buy-credits',getParentRoute: () => AuthedRoute
          })
const AuthedAppRoute = AuthedAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => AuthedRoute
          })
const AuthedAgentRoute = AuthedAgentRouteImport.update({
            id: '/agent',path: '/agent',getParentRoute: () => AuthedRoute
          })
const AuthedAdminRoute = AuthedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthedRoute
          })
const IntegrationsOutlookCallbackRoute = IntegrationsOutlookCallbackRouteImport.update({
            id: '/integrations/outlook/callback',path: '/integrations/outlook/callback',getParentRoute: () => rootRouteImport
          })
const IntegrationsGmailCallbackRoute = IntegrationsGmailCallbackRouteImport.update({
            id: '/integrations/gmail/callback',path: '/integrations/gmail/callback',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthedSupportTicketIdRoute = AuthedSupportTicketIdRouteImport.update({
            id: '/support_/$ticketId',path: '/support/$ticketId',getParentRoute: () => AuthedRoute
          })
const AuthedPartnersResourcesRoute = AuthedPartnersResourcesRouteImport.update({
            id: '/partners/resources',path: '/partners/resources',getParentRoute: () => AuthedRoute
          })
const AuthedPartnersDashboardRoute = AuthedPartnersDashboardRouteImport.update({
            id: '/partners/dashboard',path: '/partners/dashboard',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdRoute = AuthedDealsDealIdRouteImport.update({
            id: '/deals/$dealId',path: '/deals/$dealId',getParentRoute: () => AuthedRoute
          })
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminSuppressionRoute = AuthedAdminSuppressionRouteImport.update({
            id: '/suppression',path: '/suppression',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminSupportRoute = AuthedAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminReferralsRoute = AuthedAdminReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminPartnersRoute = AuthedAdminPartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminLedgerRoute = AuthedAdminLedgerRouteImport.update({
            id: '/ledger',path: '/ledger',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminLeadsRoute = AuthedAdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminHarnessRoute = AuthedAdminHarnessRouteImport.update({
            id: '/harness',path: '/harness',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminFailuresRoute = AuthedAdminFailuresRouteImport.update({
            id: '/failures',path: '/failures',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminEmailsRoute = AuthedAdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminDirectoryContactsRoute = AuthedAdminDirectoryContactsRouteImport.update({
            id: '/directory-contacts',path: '/directory-contacts',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminDashboardRoute = AuthedAdminDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminCreditsRoute = AuthedAdminCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => AuthedAdminRoute
          })
const AuthedDealsDealIdReportsRoute = AuthedDealsDealIdReportsRouteImport.update({
            id: '/deals/$dealId_/reports',path: '/deals/$dealId/reports',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdRefineRoute = AuthedDealsDealIdRefineRouteImport.update({
            id: '/deals/$dealId_/refine',path: '/deals/$dealId/refine',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdPlanRoute = AuthedDealsDealIdPlanRouteImport.update({
            id: '/deals/$dealId_/plan',path: '/deals/$dealId/plan',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdDeckStudioRoute = AuthedDealsDealIdDeckStudioRouteImport.update({
            id: '/deals/$dealId_/deck-studio',path: '/deals/$dealId/deck-studio',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdContactsRoute = AuthedDealsDealIdContactsRouteImport.update({
            id: '/deals/$dealId_/contacts',path: '/deals/$dealId/contacts',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdCapabilitiesRoute = AuthedDealsDealIdCapabilitiesRouteImport.update({
            id: '/deals/$dealId_/capabilities',path: '/deals/$dealId/capabilities',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdAgentdartRoute = AuthedDealsDealIdAgentdartRouteImport.update({
            id: '/deals/$dealId_/agentdart',path: '/deals/$dealId/agentdart',getParentRoute: () => AuthedRoute
          })
const AuthedAdminUsersUserIdRoute = AuthedAdminUsersUserIdRouteImport.update({
            id: '/users_/$userId',path: '/users/$userId',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminSupportTicketIdRoute = AuthedAdminSupportTicketIdRouteImport.update({
            id: '/support_/$ticketId',path: '/support/$ticketId',getParentRoute: () => AuthedAdminRoute
          })
const AuthedDealsDealIdTermSheetReportIdRoute = AuthedDealsDealIdTermSheetReportIdRouteImport.update({
            id: '/deals/$dealId_/term-sheet/$reportId',path: '/deals/$dealId/term-sheet/$reportId',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdRaiseStrategyReportIdRoute = AuthedDealsDealIdRaiseStrategyReportIdRouteImport.update({
            id: '/deals/$dealId_/raise-strategy/$reportId',path: '/deals/$dealId/raise-strategy/$reportId',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdModelReviewReportIdRoute = AuthedDealsDealIdModelReviewReportIdRouteImport.update({
            id: '/deals/$dealId_/model-review/$reportId',path: '/deals/$dealId/model-review/$reportId',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdMarketCompsReportIdRoute = AuthedDealsDealIdMarketCompsReportIdRouteImport.update({
            id: '/deals/$dealId_/market-comps/$reportId',path: '/deals/$dealId/market-comps/$reportId',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdInvestorsContactIdRoute = AuthedDealsDealIdInvestorsContactIdRouteImport.update({
            id: '/deals/$dealId_/investors/$contactId',path: '/deals/$dealId/investors/$contactId',getParentRoute: () => AuthedRoute
          })
const AuthedDealsDealIdDealUpdateReportIdRoute = AuthedDealsDealIdDealUpdateReportIdRouteImport.update({
            id: '/deals/$dealId_/deal-update/$reportId',path: '/deals/$dealId/deal-update/$reportId',getParentRoute: () => AuthedRoute
          })
const AuthedAdminUsersUserIdDealsDealIdRoute = AuthedAdminUsersUserIdDealsDealIdRouteImport.update({
            id: '/users_/$userId_/deals/$dealId',path: '/users/$userId/deals/$dealId',getParentRoute: () => AuthedAdminRoute
          })





const AuthedAdminRouteChildren = {
  AuthedAdminCreditsRoute: AuthedAdminCreditsRoute,AuthedAdminDashboardRoute: AuthedAdminDashboardRoute,AuthedAdminDirectoryContactsRoute: AuthedAdminDirectoryContactsRoute,AuthedAdminEmailsRoute: AuthedAdminEmailsRoute,AuthedAdminFailuresRoute: AuthedAdminFailuresRoute,AuthedAdminHarnessRoute: AuthedAdminHarnessRoute,AuthedAdminLeadsRoute: AuthedAdminLeadsRoute,AuthedAdminLedgerRoute: AuthedAdminLedgerRoute,AuthedAdminPartnersRoute: AuthedAdminPartnersRoute,AuthedAdminReferralsRoute: AuthedAdminReferralsRoute,AuthedAdminSupportRoute: AuthedAdminSupportRoute,AuthedAdminSuppressionRoute: AuthedAdminSuppressionRoute,AuthedAdminUsersRoute: AuthedAdminUsersRoute,AuthedAdminIndexRoute: AuthedAdminIndexRoute,AuthedAdminSupportTicketIdRoute: AuthedAdminSupportTicketIdRoute,AuthedAdminUsersUserIdRoute: AuthedAdminUsersUserIdRoute,AuthedAdminUsersUserIdDealsDealIdRoute: AuthedAdminUsersUserIdDealsDealIdRoute
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(AuthedAdminRouteChildren)



const AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,AuthedAgentRoute: AuthedAgentRoute,AuthedAppRoute: AuthedAppRoute,AuthedBuyCreditsRoute: AuthedBuyCreditsRoute,AuthedDashboardRoute: AuthedDashboardRoute,AuthedProfileRoute: AuthedProfileRoute,AuthedSupportRoute: AuthedSupportRoute,AuthedTeamRoute: AuthedTeamRoute,AuthedDealsDealIdRoute: AuthedDealsDealIdRoute,AuthedPartnersDashboardRoute: AuthedPartnersDashboardRoute,AuthedPartnersResourcesRoute: AuthedPartnersResourcesRoute,AuthedSupportTicketIdRoute: AuthedSupportTicketIdRoute,AuthedDealsDealIdAgentdartRoute: AuthedDealsDealIdAgentdartRoute,AuthedDealsDealIdCapabilitiesRoute: AuthedDealsDealIdCapabilitiesRoute,AuthedDealsDealIdContactsRoute: AuthedDealsDealIdContactsRoute,AuthedDealsDealIdDeckStudioRoute: AuthedDealsDealIdDeckStudioRoute,AuthedDealsDealIdPlanRoute: AuthedDealsDealIdPlanRoute,AuthedDealsDealIdRefineRoute: AuthedDealsDealIdRefineRoute,AuthedDealsDealIdReportsRoute: AuthedDealsDealIdReportsRoute,AuthedDealsDealIdDealUpdateReportIdRoute: AuthedDealsDealIdDealUpdateReportIdRoute,AuthedDealsDealIdInvestorsContactIdRoute: AuthedDealsDealIdInvestorsContactIdRoute,AuthedDealsDealIdMarketCompsReportIdRoute: AuthedDealsDealIdMarketCompsReportIdRoute,AuthedDealsDealIdModelReviewReportIdRoute: AuthedDealsDealIdModelReviewReportIdRoute,AuthedDealsDealIdRaiseStrategyReportIdRoute: AuthedDealsDealIdRaiseStrategyReportIdRoute,AuthedDealsDealIdTermSheetReportIdRoute: AuthedDealsDealIdTermSheetReportIdRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,AboutRoute: AboutRoute,AffiliateTermsRoute: AffiliateTermsRoute,AgentdartRoute: AgentdartRoute,AuthRoute: AuthRoute,CompareRoute: CompareRoute,ConnectRoute: ConnectRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,PartnersRoute: PartnersRoute,PrivacyRoute: PrivacyRoute,SampleContactRoute: SampleContactRoute,SampleDashboardRoute: SampleDashboardRoute,SampleDealRoute: SampleDealRoute,SampleReportRoute: SampleReportRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,VerifyEmailRoute: VerifyEmailRoute,ClaimTokenRoute: ClaimTokenRoute,ConnectCapabilitiesRoute: ConnectCapabilitiesRoute,ConnectChatgptRoute: ConnectChatgptRoute,ConnectClaudeRoute: ConnectClaudeRoute,HelpSlugRoute: HelpSlugRoute,HelpEmailConnectionsRoute: HelpEmailConnectionsRoute,ListsSlugRoute: ListsSlugRoute,PartnersApplyRoute: PartnersApplyRoute,VerifyEmailTokenRoute: VerifyEmailTokenRoute,HelpIndexRoute: HelpIndexRoute,ListsIndexRoute: ListsIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,IntegrationsGmailCallbackRoute: IntegrationsGmailCallbackRoute,IntegrationsOutlookCallbackRoute: IntegrationsOutlookCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)